import React from 'react';
import Layout from '@/components/layout/Layout';
import ProcurementDamageReport from '@/components/reports/ProcurementDamageReport';

const ProcurementDamageReportPage: React.FC = () => {
  return (
    <Layout>
      <ProcurementDamageReport />
    </Layout>
  );
};

export default ProcurementDamageReportPage;
